module.exports = __webpack_public_path__ + "6c8807219b0ecffdf96122b80df3e62c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-Regular.woff2
// module id = 1803
// module chunks = 1